import apiClient from "@/api/axios";

/**
 * Obtener la información del dashboard
 * @returns {Promise<any>} Información del dashboard
 */
export const getDashboardInfo = async () => {
    try {
        const response = await apiClient.get('/admin/dashboard');
        return response.data;
    } catch (error) {
        console.error('Error al obtener el dashboard:', error);
        throw error;
    }
};

/**
 * Obtener los logs del sistema
 * @returns {Promise<any>}
 */
export const getLogs = async () => {
    try {
        const response = await apiClient.get('/admin/logs');
        return response.data;
    } catch (error) {
        console.error('Error al obtener los logs:', error);
        throw error;
    }
};
